import { createRouter, createWebHistory } from 'vue-router';
import LandingPage from '../pages/LandingPage.vue';
import AboutPage from '../pages/AboutPage.vue';
import ContactPage from '../pages/ContactPage.vue';
import bloodDonation from '../pages/BloodDonation.vue';
import GalleryPage from '../pages/GalleryPage.vue';
import MembersPage from '../pages/MembersPage.vue';
import MemberDetailsPage from '../pages/MemberDetailsPage.vue';
import MemberRegister from '../pages/MemberRegister.vue';
import CouncilPage from '../pages/CouncilPage.vue';
import EventSinglePage from '../pages/EventSinglePage.vue';
import EventPage from '../pages/EventPage.vue';
import NotFound from '../pages/NotFound.vue';

const routes = [
    { path: '/', name: 'Landing', component: LandingPage },
    { path: '/about', name: 'About', component: AboutPage },
    { path: '/contact', name: 'Contact', component: ContactPage },
    { path: '/blood-donation', name: 'bloodDonation', component: bloodDonation },
    { path: '/gallery', name: 'GalleryPage', component: GalleryPage },
    { path: '/members', name: 'MembersPage', component: MembersPage },
    { path: '/member/:member_code', name: 'MemberDetailsPage', component: MemberDetailsPage },
    { path: '/member-register', name: 'MemberRegister', component: MemberRegister },
    { path: '/council/:slug', name: 'CouncilPage', component: CouncilPage },
    { path: '/event/:slug', name: 'EventSinglePage', component: EventSinglePage },
    { path: '/events', name: 'EventPage', component: EventPage },
    { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
